import LegalLayout from '@/layouts/LegalLayout';

export default function Refunds() {
  return (
    <LegalLayout title="Cancellation and refunds" updated="draft">
      <p>
        The short version: <strong>you are charged by the second for time you actually use</strong>,
        and unused time comes straight back to your balance. There is no subscription to cancel.
      </p>

      <h2>1. There is nothing to cancel</h2>
      <p>
        MakeMyPartner has <strong>no subscription and no recurring charge</strong>. We do not keep a
        card on file by default. You buy coins when you choose to, and that is the only time you are
        charged.
      </p>

      <h2>2. Ending a session</h2>
      <p>
        Either person can end a session at any moment. Billing stops the second the session does.
      </p>
      <ul>
        <li>
          <strong>Time you did not use is returned to your coin balance automatically</strong>,
          within seconds, calculated to the second.
        </li>
        <li>
          A <strong>minimum billable period of 60 seconds</strong> applies once a call connects.
        </li>
        <li>
          <strong>If the call never connects, you are not charged at all</strong> and the full
          authorised amount is returned.
        </li>
      </ul>
      <p>You do not need to contact us for any of this. It happens on its own.</p>

      <h2>3. When something goes wrong</h2>
      <p>We refund the affected time to your coin balance, without needing you to ask, when:</p>
      <ul>
        <li>A session is billed but never connected</li>
        <li>Our systems fail during a session</li>
        <li>A session is force-ended by us for a reason that is not your fault</li>
      </ul>
      <p>
        If you were charged for a session that did not happen, or the duration looks wrong, contact
        us. Every charge is backed by a second-by-second record, so a dispute can be settled from
        the actual data rather than from memory.
      </p>

      <h2>4. Refunding unconsumed coins to your bank</h2>
      <p>
        <strong>Consumed coins are not refundable.</strong> The service was delivered and the
        companion has been paid for that time.
      </p>
      <p>For coins you have bought but not yet spent:</p>
      <ul>
        <li>
          Request within <strong>7 days</strong> of purchase
        </li>
        <li>Only unconsumed purchased coins qualify</li>
        <li>
          <strong>Bonus and promotional coins are never refundable</strong> — no money was paid for
          them
        </li>
        <li>Payment-gateway charges already incurred may be deducted</li>
        <li>Approved refunds return to the original payment method</li>
        <li>
          Expect <strong>5&ndash;7 working days</strong> for the money to reach you, depending on
          your bank
        </li>
      </ul>
      <p>
        Requests outside 7 days are considered case by case. Repeated refund requests may be
        declined and may lead to account restrictions.
      </p>

      <h2>5. Coins are not a wallet</h2>
      <p>
        Coins are a prepayment for our services, not stored money. They cannot be transferred to
        another user, and they cannot be withdrawn as cash outside the process above.
      </p>
      <p>
        <strong>Bonus coins expire 90 days</strong> after they are issued, and are always spent
        before purchased coins.
      </p>

      <h2>6. How to request a refund</h2>
      <ol>
        <li>
          Go to <a href="/contact">Contact</a> and choose &ldquo;Refund request&rdquo;
        </li>
        <li>Give your registered mobile number and the payment reference</li>
        <li>Tell us briefly what happened</li>
      </ol>
      <p>
        We acknowledge within <strong>48 hours</strong> and decide within{' '}
        <strong>7 working days</strong>. If we decline, we tell you why, and you can escalate to the
        Grievance Officer.
      </p>

      <h2>7. Payment disputes</h2>
      <p>
        If you think a charge is wrong,{' '}
        <strong>please contact us before raising a chargeback</strong>. We can almost always resolve
        it faster than your bank can, and we hold the session records needed to settle it.
      </p>
      <p>
        Accounts with an open payment dispute may have recharges paused while it is investigated.
      </p>

      <h2>8. Companion payouts</h2>
      <p>
        This policy covers members. Companion earnings, holding periods and payout schedules are
        governed by the separate Companion Agreement.
      </p>

      <p>
        <strong>[FOR COUNSEL]</strong> — please confirm the 7-day window, the gateway-fee deduction
        and the bonus-coin expiry are all compliant with the Consumer Protection (E-Commerce) Rules
        2020, and that the non-refundable-once-consumed position is clearly and prominently
        disclosed at the point of purchase.
      </p>
    </LegalLayout>
  );
}
